// AboutPage.js
'use client';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import AboutPage from '../page/AboutPage.jsx';

const mapDispatchToProps = dispatch => {
  return {
    close: () => dispatch(goBack()),
  };
};

export default connect(null, mapDispatchToProps)(AboutPage);
